import Util from '../../../../shared/util/util';
import {createToast} from '../../../../shared/components/toasts/another-toast/toaster';
import TransferReportOwnership from '../../../../../mutations/reporting/TransferReportOwnershipMutation';
import {ReportRow} from '../../ReportTypes';
import {IntlShape} from 'react-intl';
import {MODAL_TYPE, showModal} from '../../../../shared/components/modals/generic_modal_conductor';
import type {TransferOwnershipModal_viewer$data as TransferOwnershipModal_viewer} from './__generated__/TransferOwnershipModal_viewer.graphql';

export type newOwnerType = NonNullable<
	NonNullable<
		NonNullable<NonNullable<NonNullable<TransferOwnershipModal_viewer['company']>['allPersons']>['edges']>[0]
	>['node']
>;

const transferOwnershipMutation = (report: ReportRow, newOwner: newOwnerType, intl: IntlShape): void => {
	const onSuccess = () => {
		createToast({
			duration: 5000,
			message: intl.formatMessage(
				{id: 'common.feedback.ownership_transferred'},
				{entity: intl.formatMessage({id: 'common.report'}).toLowerCase(), newOwner: newOwner.fullName}
			),
		});
	};
	Util.CommitMutation(
		TransferReportOwnership,
		{
			reportId: report.id,
			newOwnerId: newOwner.id,
		},
		onSuccess
	);
};

export const transferOwnership = (report: ReportRow, intl: IntlShape): void => {
	showModal({
		type: MODAL_TYPE.TRANSFER_REPORT_OWNERSHIP_MODAL,
		transferOwnership: (newOwner: newOwnerType) => transferOwnershipMutation(report, newOwner, intl),
		report: report,
	});
};
